import { render, staticRenderFns } from "./QuarantineLocation.vue?vue&type=template&id=82584d2a&scoped=true&"
import script from "./QuarantineLocation.vue?vue&type=script&lang=js&"
export * from "./QuarantineLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82584d2a",
  null
  
)

export default component.exports